<template>
  <div class="container">
    <div class="item-container">
      <div class="tipView">
      <div class="tip">如何更改/设置Wi-Fi</div>
      <div class="tipImageView">
       <!-- <div class="titleImg"><label class="titlegn">0</label></div> -->
        <h1 class="titlegn2">请尝试下载APP配网</h1>
        <div class="titlegn4">
          <!-- <h4 class="txt1">若您多次尝试依然不成功</h4>
          <h4 class="txt2" >请尝试下载APP配网</h4> -->
          <!-- <div class="wifilogo" :style="{backgroundImage: 'url('+imgSrc5+')'}"></div> -->
          <div class="wifilogo" :style="{backgroundImage: 'url('+imgSrc5+')'}"></div>
          <txt class="txt3">秒秒测配网</txt>
        <div class="tubiao" @click="downloadApp(this)"><img :src="imgSrc9" alt=""> iphone下载</div>
        <div class="tubiao" @click="weixinTip(this)"><img :src="imgSrc6" alt=""> Android下载</div>
        </div><br>


        <h4 class="titlegn2"> 微信端配网</h4><br>

        <div class="titleImg">
          <label class="titlegn">1</label>
        </div>
        <h4 class="titlegn1">手机接入2.4GWi-Fi（点击下方链接查看如何判断当前Wi-Fi是2.4G）</h4>
        <button class="titBtn" @click="goGood()">https://jingyan.baidu.com/article/d5a880eb<br>e068f413f147cccb.html；</button>
        <div class="titleImg">
<!--        <label class="titlegn">2</label>-->
<!--        </div>-->
<!--        <h4 class="titlegn1">点“下一步”进入微信“配置设备上网”界面，请您先输入密码（有的手机可能需要手动输入SSID），但是注意先不要点“连接”按键；</h4>-->
<!--        <div class="pic" :style="{backgroundImage: 'url('+imgSrc+')'}"></div>-->
<!--        <div class="titleImg">-->
        <label class="titlegn">2</label>
        </div>
        <h4 class="titlegn1">长按日历设备左键，可以看见“成功进入配网模式”的提示；</h4>
        <div class="pic3" :style="{backgroundImage: 'url('+imgSrc3+')'}"></div>
        
        <div class="titleImg">
        <label class="titlegn">3</label>
        </div>

        <h4 class="titlegn1">点“下一步”进入微信“配置设备上网”界面，请您输入密码（有的手机可能需要手动输入SSID），然后点击“连接”。</h4>
        <div class="pic" :style="{backgroundImage: 'url('+imgSrc4+')'}"></div>
        <div class="lineView"></div>

        <div class="wxtip" id="JweixinTip">

        <span class="wxtip-icon"></span>

        <p class="wxtip-txt">点击右上角<br/>选择在浏览器中打开</p>

        </div>
        <!-- <a class="titbottomBtn" @click="gowifitips(this)">若您尝试2~3次依然不成功，请看这里</a>
                <div class="pic" :style="{backgroundImage: 'url('+imgSrc5+')'}"></div> -->
      </div>
      </div>
    </div>
    <h4 class="bottomTip">请先仔细阅读相关文案，再点击“下一步”按键</h4>
    <button class="btnsave" @click="getWxConfig(this)">下一步</button>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'
import wx from 'weixin-js-sdk'
// import { Calendar } from "vant";
// import { Cell } from "vant";
import axios from 'axios'
var isLocal = Common.getEvn()
var _local = window.location.href
var api = process.env.BASE_URL
export default {
  data () {
    return {
      date: '',
      show: false,
      imgSrc: Common.staticHref() + 'img/tu2.png',
      imgSrc3: Common.staticHref() + 'img/tu3.png',
      imgSrc4: Common.staticHref() + 'img/tu4.png',
      imgSrc5: Common.staticHref() + 'img/wifilogo.png',
      imgSrc6: Common.staticHref() + 'img/icon_android.png',
      imgSrc7: Common.staticHref() + 'img/icon_android@2.x.png',
      imgSrc8: Common.staticHref() + 'img/icon_apple@3x.png',
      imgSrc9: Common.staticHref() + 'img/icon_apple.png',
    }
  },
  components: {
    NavBar,
    MenuList
    // [Calendar.name]: Calendar,
    // [Cell.name]: Cell,
  },
  methods: {
    leftClick () {
      this.$router.push({path: '/Setting'})
    },
    goPage (e) {
      if (e === 'hot') {
        this.$router.push({ path: '/hotSetting' })
      } else if (e === 'down') {
        this.$router.push({ path: '/BatchDownload' })
      }
    },
    gowifitips (_this) {
      // eslint-disable-next-line one-var
      let that = this,
        _url = api + '/Calendar/api/version/get/device/version/info/',
        _deviceId = localStorage.getItem('max_device_id')
      if (isLocal === 'local') {
        _url = '/Calendar/api/version/get/device/version/info/'
        _deviceId = localStorage.getItem('max_device_id')
      }
      that.toast = that.$createToast({
        time: 0,
        txt: '请稍后',
        mask: true
      }).show()
      axios.post(_url, {
        'device_id': _deviceId
      })
        .then(res => {
          that.toast.hide()
          let _ware = res.data.info.software
          console.log('=========>>>>' + _deviceId)
          // alert(_ware+"{cw }")
          console.log(_ware)
          if (!_ware) {
            this.$router.push({path: '/UpgradeVersionInstructions2', params: this.max_device_id})
          } else {
            let _infos = _ware.split('_')
            let _mcu = _infos[1]
            _mcu = parseInt(_mcu)
            if (_mcu > 63) {
              // 0102及以上固件显示Wi-Fi配置提醒
              this.$router.push({path: '/UpgradeVersionInstructions3'})
            } else {
              this.$router.push({path: '/UpgradeVersionInstructions'})
            }
          }
        })
        .catch(reason => {
          if (that.retry === 0) {
            that.retry = 1
            that.checkVersion_WIFI()
          } else {
            this.$router.push({path: '/UpgradeVersionInstructions'})
          }
        })
    },
     // 获取wxConfig所需要的配置项
    getWxConfig (_this) {
      let currentURL = encodeURIComponent(location.href.split('#')[0])
      // (currentURL)
      if (Common.getEvn() === 'local') {
        axios.get('/mmc/api/wx_user/get_token/?url=' + currentURL)
        .then(this.getWxConfigSucc)
        .catch(this.getWxConfigError)
      } else {
        axios.get(api + '/mmc/api/wx_user/get_token/?url=' + currentURL)
        .then(this.getWxConfigSucc)
        .catch(this.getWxConfigError)
      }
    },
    getWxConfigSucc (res) {
      let result = res.data.result
      console.log('---------->>>>>>' + result.timestamp)
      this.changeWifi()
    },
    getWxConfigError (res) {
      alert(res)
    },
    changeWifi () {
      this.configWifi(this)
    },
    configWifi (_this) {
      wx.invoke('configWXDeviceWiFi', {}, function (res) {
        console.log(res)
        var errMsg = res.err_msg
        if (errMsg === 'configWXDeviceWiFi:ok') {
          // 配置成功
          // alert('WIFI配置成功')
          // 配网成功之后的回调地址
          _this.$router.push({path: '/wifiSuccess', query: {pageName: _this.fromPage}})
        } else if (errMsg === 'configWXDeviceWiFi:fail') {}
      })
    },
    /* 判断用户手机为安卓还是iphone */
    checkPhone () {
    let self = this
    let agent = (navigator.userAgent || navigator.vendor || window.opera)
                console.log(agent,"><<<<<")

      if (agent != null) {
      let agentName = agent.toLowerCase()
         console.log(agentName,"1111111")
          if (/android/i.test(agentName)) {
            console.log(agentName,"22222")
            console.log("33333")
            self.isAndroid = true
          } else if (/mozilla/i.test(agentName)) {
            self.isIOS = true
          }
      }
    },
    /* 判断是否为微信环境 */
    /* 点击下载按钮 */
    downloadApp () {
          // 微信环境
          let self = this
          self.isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
          self.checkPhone()
          let agent = (navigator.userAgent || navigator.vendor || window.opera)
          console.log("><<<<<")
          if (agent != null) {
            let agentName = agent.toLowerCase()
            // this.$alert({text: [agentName]})
            console.log(self.isAndroid,"<<<<<<<")
            if (self.isAndroid) {
               // 微信环境
               console.log(self.isWeiXin,"<<<<<<<")
              if (self.isWeiXin) {
                self.downloadInWeixin = true
                window.location.hash = 'download'   // 改变hash，便于浏览器打开时直接下载安卓包
                return
              }
              // 安卓包下载地址
              window.location.href = 'https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk'

            } else if (self.isIOS) {
               // 微信环境
              if (self.isWeiXin) {
                window.location.href = 'https://apps.apple.com/cn/app/%E7%A7%92%E7%A7%92%E6%B5%8B%E9%85%8D%E7%BD%91/id1599474796'
                // self.downloadInWeixin = true
                // window.location.hash = 'download'    // 改变hash，便于浏览器打开时直接跳转AppStore
                return
              }
              // 苹果商店链接地址
              window.location.href = 'https://apps.apple.com/cn/app/%E7%A7%92%E7%A7%92%E6%B5%8B%E9%85%8D%E7%BD%91/id1599474796'
            } else {
              console.log({text: ['暂不支持，敬请期待~']})
            }
          }
        },

    identityHash () {
        let self = this
        console.log(">>>>>>",window.location.hash)
        if (window.location.hash.includes('download')) {
              window.location.hash = ''   //  还原hash为空
              self.checkPhone()
              if (self.isAndroid) {
                // 安卓，弹出包下载页面
                window.location.href = 'https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk'
              } else if (self.isIOS) {
              // ios，直接跳转Appstore
               window.location.href = 'https://apps.apple.com/cn/app/%E7%A7%92%E7%A7%92%E6%B5%8B%E9%85%8D%E7%BD%91/id1599474796'
            } else {
              this.$alert({text: ['暂不支持，敬请期待~']})
            }
          }
      },

    getandroid(){
      var isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
      var u = navigator.userAgent;
      window.location.href = "https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk";
      // var u = navigator.userAgent;
      console.log(u + "请在浏览器上打开" )

      // var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1 // 微信内
      // console.log("请在浏览器上打开",isWeixin)
      // android终端
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
      // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
              //安卓app的scheme协议
              setTimeout(function () {
                  let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                  if (typeof hidden == "undefined" || hidden == false) {
                      window.location.href = "https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk";
                  }
              }, 2000);
          }

      // 微信内
      var isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
      if (!isWeixin) {
        alert('请在浏览器上打开')
      } else {
          //android端
          if (isAndroid) {
              //安卓app的scheme协议
              setTimeout(function () {
                  let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                  if (typeof hidden == "undefined" || hidden == false) {
                      //应用宝下载地址 (emmm 找不到淘宝应用宝的地址，这里放的是 lucky coffee 地址)
                      window.location.href = "https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk";
                  }
              }, 2000);
          }
}    },
    

    getiphone(){console.log("++++++11111")},
    
    weixinTip(){
    var btn1 = document.getElementById('JdownApp')//下载一

    var ua = navigator.userAgent;
    console.log(">>>>>>")
    var isWeixin = !!/MicroMessenger/i.test(ua);
    console.log(">>>>>>",isWeixin)
    if(isWeixin){
    document.getElementById('JweixinTip').style.display='block';
    }else{
                    window.location.href = 'https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk'
    }
    },
    goGood () {
      window.location.replace('https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk')
    }
  },
  mounted:function(){
            // 微信内
      var isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
      if (!isWeixin) {
        window.location.href = "https://cdn.cnbj2.fds.api.mi-img.com/common/max/prod/APK/wifi-config-app-release-7.apk";
      }

  },
  // mounted:{

  // },
  created () {
    Common.setTitle('更改/设置Wi-Fi')
  }
}
</script>
<style lang="stylus" scoped>
.btnsave
  background-color #000000
  margin-top 10px
  margin-left 20px
  width 89.3vw
  height 44px
  font-size 16px
  color #FFFFFF
.bottomTip
  color #000000
  font-size 12px
  margin-top 20px
  text-align center
.item-container
  height: calc(100% - 90px);
  overflow: auto;
  .tipView
   background: -webkit-linear-gradient(bottom,rgba(0, 0, 0, 0.6),#000000)
   margin-top 0px
   height 200px
   width 100%
  .tipImageView
     background-color #FFFFFF
     height 1630px
     margin-left 15px
     margin-right 15px
     margin-top 15px
     border-radius 8px
     padding-top 23px
  .tip
    font-size 28px
    line-height 40px
    padding-top  45px
    color #FFFFFF
    text-align center
  .titleImg
    display flex
    height 22px
    width 22px
    margin-left 10px
    border-radius 20px
    background-color #000000
    align-items center
    justify-content center
  .titlegn
    font-size 14px
    color #FFFFFF
  .titlegn1
    font-size  14px
    color #333333
    height 40px
    line-height 20px
    margin-left 47px
    margin-right 10px
    margin-top -22px
  .titlegn4
    font-size  14px
    margin-top 30px
    text-align: center;
  .titlegn4 .txt1
    margin-bottom: 5px
  .titlegn4 .txt2
    margin-bottom: 43px
  .titlegn4 .txt3
    font-size: 14px;
    color: #3F414F;
    font-size  10px;
    margin-top: 30px;
  .titlegn4 .tubiao
    text-align: center;
    margin: auto
    width: 235px
    height: 44px
    font-size: 16px;
    line-height:40px
    margin-top: 20px
    border: 1px solid #979797;
    border-radius: 22px;
    border-radius: 22px;
    vertical-align:baseline;
    // text-align:center;

  .titBtn
    font-size 14px
    color #1177EC
    background-color #FFFFFF
    margin-top 15px
    margin-left 47px
    margin-right 10px
    text-align left
    padding-bottom 17px
  .titbottomBtn
    font-size 14px
    display block
    color #000
    line-height 20px
    text-decoration underline
    text-align center
  .titbottomBtn:visited
    color #000
  .pic
    height 69vh
    // width calc(69vh * 0.76)
    margin-left 44px
    margin-right 10px
    // margin-top 15px
    background-position center center
    background-repeat no-repeat
    background-size contain
    // background-color blue
    // margin 0 auto;
  .pic3
    height 59vh
    // width calc(69vh * 0.76)
    margin-left 44px
    margin-right 10px
    // margin-top 15px
    background-position center center
    background-repeat no-repeat
    background-size contain
    // background-color blue
    // margin 0 auto;
  .wifilogo
    height 100px
    width  100px;
    margin: auto
    background-position center center
    background-repeat no-repeat
    background-size contain
    bottom: 10px
  .lineView
    background-color #D8D8D8
    height 1px
    box-sizing border-box
    margin 0 15px 30px
  .lineBottomView
    background-color #000000
    height 1px
    margin-left 20px
    margin-right 20px
  .bottomLine
   margin-bottom -78px
   font-size 12px
   background-color blue
  .wxtip{background: rgba(0,0,0,0.8); text-align: center; position: fixed; left:0; top: 0; width: 100%; height: 100%; z-index: 998; display: none;}

  .wxtip-icon{width: 52px; height: 67px; background: url() no-repeat; display: block; position: absolute; right: 20px; top: 20px;}

  .wxtip-txt{margin-top: 107px; color: #fff; font-size: 16px; line-height: 1.5;}
  .titlegn2
    margin-left: 5vw
</style>




// WEBPACK FOOTER //
// src/pages/ConfigWiFi/ConfigWiFi120.vue